import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap'
import swal from 'sweetalert';
import Select from 'react-select';
import { DateRangePicker } from 'react-dates';
import "react-dates/lib/css/_datepicker.css";
import 'react-dates/initialize';
import moment from 'moment';
import $ from 'jquery';
/* dadatable */
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";



export default function AgentalBal(props) {
  const [tableData, setTableData] = useState([]);
  const [items, setitems] = useState({ bookingdate: "", bookingdatefwd: "", bookingdateback: "", UnitId:"" })
  const [data, setdata] = useState([])
  const [addunit, setunit] = useState([])
  const [unitvalue, setunitvalue] = useState()
  const [itemsfilter, setitemsfilter] = useState([]);
  const [unitError, setUnitError] = useState();
  const [agentuser, setagentuser] = useState([]);
  const [agentuservalue, setagentuservalue] = useState([])
  /* TOTAL OF TABLES DATA */
  const [totalAmount, setTotalAmount] = useState(0);
  const [beforeDiscount, setBeforeDiscount] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [received, setReceived] = useState(0);
  useEffect(() => {
    const totalAmountSum = tableData.reduce((acc, rowData) => acc + (rowData.totalAmount || 0), 0);
    const beforeDiscountSum = tableData.reduce((acc, rowData) => acc + (rowData.beforediscount || 0), 0);
    const totalDiscountSum = tableData.reduce((acc, rowData) => acc + (Number(rowData.discount) || 0), 0);
    const receivedSum = tableData.reduce((acc, rowData) => acc + (rowData.received || 0), 0);

    setTotalAmount(totalAmountSum);
    setBeforeDiscount(beforeDiscountSum);
    setTotalDiscount(totalDiscountSum);
    setReceived(receivedSum);
  }, [tableData]);
  
  useEffect(() => {
      fetchUnitdata()
  }, [])
  useEffect(() => {
    if ($.fn.DataTable.isDataTable('#example3')) {
      $('#example3').DataTable().destroy();
    }

    if (tableData.length > 0) {
      $('#example3').DataTable({
        data: tableData,
        destroy: true,
        columns: [
          { data: 'bookingdate', render: data => moment(data).format('DD, MMM, YYYY') || '--' },
          { data: 'bookingNo' },
          { data: 'customerName' },
          { data: 'beforediscount' },
          { data: 'discount' },
          { data: 'totalAmount' },
          { data: 'received' },
        ],
      });
      $('#example3').show().css({ width: '100%' });
    } else {
      $('#example3').hide();
    }
  }, [tableData]);



  async function fetchUnitdata() {
      const Uniturl = process.env.REACT_APP_APIURL + "FramUnit/GetFramUnits?companyid=" + props.companyid;
      let Unitdata = await axios.get(Uniturl);
      var units = [{ value: null, label: 'All' }];
      Unitdata.data.map((u) => {
        units.push({ value: u.unitId, label: u.unitName });
      })
      setunit(units);
  }
  const setunitvalues = (e) => {

  }
  //agent user --
  const setagentuservaluefilter = (e) => {
   // debugger;
    setagentuservalue({ value: e.value, label: e.label })
}

  const onChangeDate = e => {
    //  debugger;
      const newDate = moment(new Date(e.target.value)).format('YYYY-MM-DD');
      const onefwd = moment(newDate, 'YYYY-MM-DD').add('days', 1).format('YYYY-MM-DD');
      const oneback = moment(newDate, 'YYYY-MM-DD').subtract('days', 1).format('YYYY-MM-DD');
      setitems({ ...items, bookingdate: newDate, bookingdatefwd: onefwd, bookingdateback: oneback })
      fetcheveintdata(newDate, onefwd, oneback)
  };
  async function fetcheveintdata(newDatea, onefwda, onebacka) {
   //   debugger;
      // console.log(props.companyid)
      const url = process.env.REACT_APP_APIURL + "Booking/bydatebooking?companyid=" + props.companyid + "&dt=" + newDatea + "&db=" + onebacka + "&dn=" + onefwda;
      let Unitdata = await axios.get(url);
      await setdata(Unitdata.data);
  }
  // agent gets
  async function fetchagentdata() {
    const Uniturl = process.env.REACT_APP_APIURL + "FramUnit/agent?companyid=" + props.companyid;
    let response = await axios.get(Uniturl);
    /* console.log(response); */
    var data = [{ value: null, label: 'All' }];
    response.data.map((u) => {
        data.push({ value: u.id, label: u.f_name });
    })
    setagentuser(data);
}
  // date range /
  
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);

  const handleDateChange = ({ startDate, endDate }) => {
      setStartDate(startDate);
      setEndDate(endDate);
  };
  const getSelectedDateRangeCount = () => {
      debugger;
      if (startDate && endDate) {
          return endDate.diff(startDate, 'days') + 1; // +1 to include both start and end dates
      }
      return 0;
  };
  
  const handleSubmit1 = async (e) => {
    e.preventDefault();
    if (items.UnitId == null) {
      setUnitError(false);
    }
    else if(!items.UnitId ){
      setUnitError(true);
      return;
    }
   /*  console.log(!items.UnitId, items.UnitId); */
    // Assuming Agentid is stored in itemsfilter.Agentid
    const selectedAgentId = itemsfilter.Agentid;
  
    var data = {
      UnitId: items.UnitId,
      startDate: moment(new Date(startDate)).format('YYYY-MM-DD'),
      endDate: moment(new Date(endDate)).format('YYYY-MM-DD'),
      Agentid: selectedAgentId, // Corrected property name
    };
  
    /* const url = process.env.REACT_APP_APIURL + `Agent/GetAgentBal?companyid=${props.companyid}&sdt=${data.startDate}&edt=${data.endDate}&unitid=${data.UnitId}&agentid=${data.Agentid}`; */
  const url = `${process.env.REACT_APP_APIURL}Agent/GetAgentBal?companyid=${props.companyid}` +
  `${data.startDate ? `&stdate=${data.startDate}` : ''}` +
  `${data.endDate ? `&edate=${data.endDate}` : ''}` +
  `${data.UnitId ? `&unitid=${data.UnitId}` : ''}` +
  `${data.Agentid ? `&agentid=${data.Agentid}` : ''}`;
  //  console.log(url);
    try {
      let Unitdata = await axios.get(url);
      setTableData(Unitdata.data);
      console.log(Unitdata.data);
      if (Unitdata.data.length === 0) {
        swal({
          title: "Sorry Data not found!🥲",
          icon: "error"
      })
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    
  };
  useEffect(() => {
    fetchagentdata()
}, [])

  return (
      <>
          <div className="row">
              <div className="col-12">
                  <div className="card">
                      <div className="card-header">
                          <h4 className="me-auto mb-0">Agent Bal Report</h4>
                      </div>
                      <div className="card-body">
                          <form onSubmit={handleSubmit1}>
                          <div className='row'>
                                  
                                <div className="mb-3 col-10 col-sm-6 col-md-6 col-lg-4">
                                  <label htmlFor="booking_id" className="form-label">
                                    Agent
                                  </label>
                                  <Select options={agentuser} value={agentuservalue} id="agent" onChange={(e) => {  const selectedAgentId = e.value; setagentuservaluefilter(e); setitemsfilter({ ...itemsfilter, Agentid: selectedAgentId })}} />
                                </div>
                                 {/* dateRangePicker */}

                                  <div className="mb-3 col-10 col-sm-6 col-md-6 col-lg-4">
                                      <label className="form-label">Date</label>
                                      <div className="search-inp">
                                     
                                      <DateRangePicker
                                      startDate={startDate}
                                      startDateId="start_date_id"
                                      endDate={endDate}
                                      endDateId="end_date_id"
                                      onDatesChange={handleDateChange}
                                      focusedInput={focusedInput}
                                      onFocusChange={(focusedInput) =>
                                          setFocusedInput(focusedInput)
                                      }
                                      isOutsideRange={() => false}
                                      numberOfMonths={1}
                                      displayFormat="DD/MM/YYYY"
                                      required />
                                  </div>
                              </div>
                              {/* dateRangePicker */}
                              {/* unit select */}
                              <div className="mb-3 col-10 col-sm-6 col-md-6 col-lg-4 ">
                                <label className="form-label">Select Farm</label>
                                  <Select
                                    name="unit"
                                    value={unitvalue}
                                    options={addunit}
                                    onChange={(e) => {
                                    setunitvalues(e);
                                    setitems({ ...items, UnitId: e.value });
                                    setUnitError(false); 
                                     }}
                                    required
                                  />
                                  {unitError && <div className="error-message">Farm selection is required</div>}
                              </div>
                              <div className="text-center inner-btn">
                                    <button type="submit" className="btn btn-primary" id="book">Submit</button>
                              </div>
                              </div>
                         
                          </form>
                      </div>
                      {/* card body */}


                      {/* Table */}

                      <div className="card-body">
                        <div className="table-responsive">
                            <table id="example3" className="display" data-page-length='50'>
                                <thead>
                                    <tr>
                                        <th>Booking Date</th>
                                        <th>Booking No</th>
                                        <th>Customer Name</th>
                                        <th>After Discount</th>
                                        <th>Discount</th>
                                        <th>Total Amount</th>
                                        <th>Received Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th>After Discount</th>
                                    <th>Discount</th>
                                    <th>Total Amount</th>
                                    <th>Received Amount</th>
                                </tr>
                                <tr className='total_amount'>
                                  <td>Total:</td>
                                  <td>--</td>
                                  <td>--</td>
                                  <td>{beforeDiscount.toLocaleString()}</td>
                                  <td>{totalDiscount.toLocaleString()}</td>
                                  <td>{totalAmount.toLocaleString()}</td>
                                  <td>{received.toLocaleString()}</td>
                                </tr>
                              </tfoot>
                            </table>
                        </div>
                    </div>
                      {/* Table */}


                  </div>
              </div>
          </div>
      </>
  );
}
